<template>
  <div>
    <div class="top-box wow animate__animated animate__fadeInDown">
      <img src="../assets/mobile/top-bg.png" art="背景图"/>
      <img src="../assets/mobile/logo.png" art="花蹊标志" class="logo"/>
    </div>
    <img src="../assets/mobile/slogan.png" art="花蹊标语" class="slogan wow animate__animated animate__zoomIn"
         data-wow-delay="1s"/>


    <img src="../assets/common/mini-title.png" alt="4岁-18岁" class="works-2"/>
    <img src="../assets/common/mini.jpg" alt="4岁-18岁"
         class="student-works wow animate__animated animate__zoomIn"/>

    <img src="../assets/common/infant-title.png" alt="幼儿部" class="works-2" style="width: 26%"/>
    <div class="layout-box">
      <img src="../assets/common/infant_left.jpg" alt="幼儿部"
           class="imgw wow animate__animated animate__zoomIn"/>
      <img src="../assets/common/infant_right.jpg" alt="幼儿部"
           class="imgw wow animate__animated animate__zoomIn"/>
    </div>

    <img src="../assets/common/primary-title.png" alt="小学部" class="works-2" style="width: 38%"/>
    <div class="teacher-works-box">
      <img src="../assets/common/primary.jpg" alt="小学部"
           class="student-works wow animate__animated animate__zoomIn"/>
    </div>

    <img src="../assets/common/middle-title.png" alt="初中部" class="works-2" style="width: 45%"/>
    <img src="../assets/common/middle.jpg" alt="初中部"
         class="student-works wow animate__animated animate__zoomIn"/>

    <img src="../assets/common/senior-title.png" alt="高中部" class="works-2" style="width: 86%"/>
    <img src="../assets/common/senior.jpg" alt="高中部"
         class="student-works wow animate__animated animate__zoomIn"/>


    <img src="../assets/common/concat.png" alt="联系我们" class="works-2" style="width: 26%"/>
    <div class="footer wow animate__animated animate__slideInUp">
      <div class="left">
        <img src="../assets/common/qr.jpg" class="qr"/>
        <img src="../assets/common/mobile.png" class="mobile"/>
      </div>
      <div class="right">
        <img src="../assets/common/campus.png" alt="花蹊校区" class="campus"/>
      </div>
    </div>
    <div class="footer-bottom">
      <img src="../assets/common/address.png" alt="花蹊" class="address"/>
      <div class="beian">工信部备案：<a href="https://beian.miit.gov.cn/" target="_blank"> 豫ICP备2023023142号-1</a>
      </div>
    </div>


  </div>
</template>

<script>
import {WOW} from 'wowjs'

export default {
  name: "mobile-index",
  data() {
    return {
      isInView: false,
      showCode: false
    }
  },

  mounted() {
    new WOW().init()
    this.$nextTick(() => {
      window.addEventListener('scroll', this.checkIfInView);
    });
    setTimeout(() => {
      this.isInView = true;
    }, 1000)

  },
  methods: {
    checkIfInView() {
      const target = this.$refs.target;
      if (!target) return
      const rect = target.getBoundingClientRect();
      const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
      const windowWidth = (window.innerWidth || document.documentElement.clientWidth);
      if (rect.top >= 0 && rect.left >= 0 && rect.bottom <= windowHeight && rect.right <= windowWidth) {
        this.isInView = true;
      }
      if (rect.bottom < 0) {
        this.isInView = false
      }
    },
  },

}
</script>

<style scoped>

.top-box {
  position: relative;
}

.logo {
  width: 46%;
  position: absolute;
  left: 27%;
  top: 7rem;
}

.slogan {
  width: 64%;
  margin: 2rem 18%;
}


.student-works {
  width: 86%;
  margin: 1rem auto;
}

.layout-box{
  width: 86%;
  display: flex;
  justify-content: center;
  margin: 0 auto;
}

.imgw {
  width: 50%;
}

.works-2 {
  width: 30%;
  margin: 2rem auto 0.5rem;
}

.footer {
  width: 86%;
  margin: 1rem auto .5rem auto;
  display: flex;
  justify-content: center;
  align-items: stretch;  /* 关键：让左右两侧等高 */
  margin: 2rem auto;
}
.footer .left,
.footer .right {
  width: 40%;
  display: flex;
  flex-direction: column;  /* 垂直排列内部图片 */
  justify-content: center; /* 内容垂直居中（或改为 flex-start 顶部对齐） */
  align-items: center;     /* 内容水平居中 */
}
.qr{
  width: 80%;
  margin: 0 auto;
}
.mobile{
  width: 100%;
  margin: .4rem auto 0;
}
.campus {
  width: 100%;
  height: 100%;        /* 让校区图填满右侧容器高度 */
  object-fit: contain; /* 保持图片比例 */
}

.footer-bottom{
  background-color: #fe4e02;
  text-align: center;
  font-size: 1.2rem;
  padding-top: 1rem;
  margin-top: 1rem;
}

.address{
  width: 26%;
  margin: 0 auto .3rem;
}

.beian {
  font-size: .7rem;
  text-align: center;
  padding: .7rem 0 .2rem 0;
}

.beian a {
  color: #ffffff;
}
</style>
